import React from "react";

interface InputProps {
  name: string;
  type: string;
  placeholder: string;
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  fullWidth?: boolean;
  startAdornment?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
  name,
  type,
  placeholder,
  label,
  value,
  onChange,
  fullWidth = false,
  startAdornment,
}) => {
  return (
    <div className="flex flex-col">
      {label && (
        <label htmlFor={name} className="text-sm font-semibold mb-1">
          {label}
        </label>
      )}
      <div
        className={`flex items-center border border-gray-300 rounded-md overflow-hidden bg-white ${
          fullWidth ? "w-full" : "w-fit"
        }`}
      >
        <div className="relative">
          {startAdornment && (
            <div className="flex items-center justify-center pl-4 pr-0">
              {startAdornment}
            </div>
          )}
        </div>
        <input
          type={type}
          placeholder={placeholder}
          className={`px-4 py-[6px] focus:outline-none placeholder:text-gray-400 placeholder:text-sm`}
          value={value}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default Input;
